<div class="flex-default">
  <mat-icon class="vcenter mrlarge clickable" [ngClass]="leftIcon.class" (click)="onIconClick(-1)">{{ leftIcon.icon }}</mat-icon>
  <mat-slider class="vcenter" [disabled]="disabled" [max]="externalToInternalValueClamped(max)"
    [min]="externalToInternalValueClamped(min)" [step]="externalToInternalValueClamped(step)">

    <input #slider matSliderThumb [value]="externalToInternalValue(value)"
      (input)="onSliderInput(internalToExternalValue(slider.value))"
      (change)="onSliderChange(internalToExternalValue(slider.value))">

  </mat-slider>
  <mat-icon class="vcenter mllarge clickable" [ngClass]="rightIcon.class" (click)="onIconClick(1)">{{ rightIcon.icon }}</mat-icon>
</div>
